import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '../dialog/dialog.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { NavigationModule } from '../navigation/navigation.module';
import { SharedModule } from '../shared/shared.module';
import { ToasterModule } from '../toaster/toaster.module';
import { CommonPaymentsDialogComponent } from './components/common-payments-dialog/common-payments-dialog.component';
import { CreditCardsComponent } from './components/credit-cards/credit-cards.component';
import { ManualPaymentDialogComponent } from './components/manual-payment-dialog/manual-payment-dialog.component';
import { PaymentOptionsComponent } from './components/payment-options/payment-options.component';
import { PaymentsMarkupComponent } from './components/payments-markup/payments-markup.component';
import { SendReceiptDialogComponent } from './components/send-receipt-dialog/send-receipt-dialog.component';
import { TurnOnPaymentsDialogComponent } from './components/turn-on-payments-dialog/turn-on-payments-dialog.component';
import { SetupBankTransferDialogComponent } from './components/setup-bank-transfer-dialog/setup-bank-transfer-dialog.component';
import { BankTransferInfoDialogComponent } from './components/bank-transfer-info-dialog/bank-transfer-info-dialog.component';
import { PaymentsInfoDialogComponent } from './components/payments-info-dialog/payments-info-dialog.component';
import { CardPaymentsInfoDialogComponent } from './components/card-payments-info-dialog/card-payments-info-dialog.component';
import { PaypalInfoDialogComponent } from './components/paypal-info-dialog/paypal-info-dialog.component';
import { OnboardingStripeDialogComponent } from './components/onboarding-stripe-dialog/onboarding-stripe-dialog.component';
// eslint-disable-next-line max-len
import { EnableStripeVerificationDialogComponent } from './components/enable-stripe-verification-dialog/enable-stripe-verification-dialog.component';
import { I2gNgUiModule } from 'i2g-ng-ui';
import { VerifyAccountModule } from '../verify-account/verify-account.module';
import { OnboardingI2gMoneyDialogComponent } from './components/onboarding-i2g-money-dialog/onboarding-i2g-money-dialog.component';
import { I2gNgTrackingModule } from 'i2g-ng-tracking';

const components = [
  CommonPaymentsDialogComponent,
  SetupBankTransferDialogComponent,
  CreditCardsComponent,
  SendReceiptDialogComponent,
  ManualPaymentDialogComponent,
  PaymentOptionsComponent,
  TurnOnPaymentsDialogComponent,
  PaymentsMarkupComponent,
  PaymentsInfoDialogComponent,
  BankTransferInfoDialogComponent,
  CardPaymentsInfoDialogComponent,
  PaypalInfoDialogComponent,
  OnboardingStripeDialogComponent,
  OnboardingI2gMoneyDialogComponent,
  EnableStripeVerificationDialogComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    NavigationModule,
    ToasterModule,
    FormMasterModule,
    I2gNgUiModule,
    VerifyAccountModule,
    I2gNgTrackingModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class PaymentsModule {}
